import React from 'react'
import { Box, Button } from '@mui/material'
import { ButtonsWrapper } from '../../StyledComponents'

function FontSizeController() {
	return (
		<Box>
			<Box sx={{ display: { lg: 'none' }, color: 'white' }}>Change Font Size:</Box>
			<ButtonsWrapper>
				<Button variant='contained' disableElevation>-A</Button>
				<Button variant='outlined'>A</Button>
				<Button variant='contained' disableElevation>+A</Button>
			</ButtonsWrapper>
		</Box>
	)
}

export default FontSizeController
